export default "__VITE_ASSET__BZu$4dIb__"